import { useMemo } from 'react';

import { StatType } from 'services/stats';
import useStats from 'hooks/useStats';

import { localToUtcTs } from 'helpers/date';

export const aggregateDoorDetailsStats = (stats) => {
  const containers = stats.filter(s => s.direction === 'UNLOAD');
  const trailers = stats.filter(s => s.direction === 'LOAD');
  const unloadedBoxes = containers.reduce((s, c) => s + c.unloaded_boxes, 0);
  const loadedBoxes = trailers.reduce((s, t) => s + t.unloaded_boxes, 0);
  
  return {
    containers: containers.length,
    trailers: trailers.length,
    boxes_unloaded: unloadedBoxes,
    boxes_loaded: loadedBoxes,
  };
};

const useDoorDetails = (doorId, dateRange = { start: null, end: null }) => {
  const doorDetails = useStats(StatType.doorDetails, {
    door_id: doorId,
    from: dateRange.start ? localToUtcTs(dateRange.start.toDate(), true) : null,
    to: dateRange.end ? localToUtcTs(dateRange.end.toDate(), true) : null,
  }, {
    initialStats: {
      door: null,
      employees: [],
      stats: [],
    },
    autoFetch: true,
    refreshInterval: 180000,
  });
  const doorTimeline = useStats(StatType.timeline, {
    door_id: doorId,
  }, {
    autoFetch: true,
    refreshInterval: 180000,
  });

  const doorDetailsData = useMemo(() => {
    const { door, stats } = doorDetails.state.stats;
    if (door) {
      door.hasAnomaly = door.is_low_accuracy === 1;
      door.warningMessage = door.warning_message || '';
      door.hasUnidentifiedEmployees = (door.unidentified_employees || 0) !== 0; 
    }
    return {
      ...doorDetails.state.stats,
      door,
      summary: aggregateDoorDetailsStats(stats),
    };
  }, [doorDetails.state.stats]);

  const timelinesData = useMemo(() => {
    let timelines = [], activeTimeline = null;
    if (doorTimeline.state.stats && doorDetailsData.door) {
      timelines = doorTimeline.state.stats;
      activeTimeline = timelines.find(c => {
        return c.unloading.container_id === doorDetailsData.door.container_id;
      });
    }
    return {
      timelines,
      activeTimeline: activeTimeline || null,
    }
  }, [doorTimeline.state.stats, doorDetailsData]);

  return {
    isLoading: doorDetails.state.isLoading || doorTimeline.state.isLoading,
    doorDetails,
    doorTimeline,
    doorDetailsData,
    timelinesData,
  };
};

export default useDoorDetails;